import {PrimeIcons} from "primereact/api";
import {InputTextarea} from "primereact/inputtextarea";

import {DetailsPanel} from "./panels";

interface PanelJsonDebugProps {
    jsonData: unknown;
    title: string;
}

export function PanelJsonDebug({jsonData, title}: PanelJsonDebugProps) {
    const debugData = JSON.stringify(jsonData, null, 4);
    return (
        <DetailsPanel icon={PrimeIcons.CODE} title={title} dataToCopy={debugData}>
            <InputTextarea value={debugData} className="w-full text-sm" autoResize readOnly />
        </DetailsPanel>
    );
}
